import { Line } from 'vue-chartjs'

import { reactiveProp } from '../../mixins/reactivechart'
import zoom from 'chartjs-plugin-zoom';
import moment from 'moment';

export default {
  extends: Line,
  mixins: [reactiveProp],
  data: () => ({
    offsetindex: 30,
    options: {
      responsive: true,
      legend: {
        labels: {
          fontColor: "white",
          fontSize: 11
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            fontColor: "white",
            fontSize: 11,
            stepSize: 1,
            beginAtZero: true
          }
        }],
        xAxes: [{
          ticks: {
            fontColor: "white",
            fontSize: 14,
            stepSize: 1,
            beginAtZero: true
          }
        }]
      },
      maintainAspectRatio: false,

      // Container for zoom options
      zoom: {
        // Boolean to enable zooming
        enabled: true,

        // Zooming directions. Remove the appropriate direction to disable
        // Eg. 'y' would only allow zooming in the y direction
        mode: 'x',
      },

      animation: {
        duration: 0
      }
    }
  }),
  methods: {
    subscribeToStore(){
      console.log("SUBSCRIBING TO LOGS FOR "+this.username);
      this.$store.subscribe((mutation, state) => {
        if(mutation.type === 'addLog'){
          var lastlog = state.logs[state.logs.length - 1];
          if(lastlog.un === this.username){
            this.incrementLastTimePeriod();
          }
        }
      })
    },
    getDataFromApi(cb){

      console.log("Loading graph data for user "+this.username)

      this.$http.get('/stats/'+this.username+'/'+this.interval+'/today/2018-09-13', {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      })
        .then(response => {

          console.log("Loading graph data for user "+this.username)

          var responsedata = response.data;
          var dates = responsedata.dates;

          var counts = responsedata.counts;



          this.updateDatasetData(dates, counts);

          cb();
        })
        .catch(e => {
          // console.log(JSON.stringify(e));


          console.log("Loading graph data for user "+this.username)
          this.$root.$emit('snackbar', e.response.data.msg)
        })


    },
    updateDatasetData(dates, counts){

      var dataPoints = {
        labels: dates,
        datasets: [
          {
            label: this.username,
            backgroundColor: '#f87979',
            data: counts
          }
        ]
      }
      this.chartData = dataPoints;

      console.log("Updated chart data for "+this.username)

      this.renderChart(this.chartData, this.options);
    },
    incrementLastTimePeriod(){
      console.log("INCREMENTING "+this.username);

      const arr = {};


      var start = new Date();
      start.setHours(0, 0, 0, 0);
      var end = new Date();



      if(!this.startdate){
        start = moment(start);
        end = moment(end);
      }


      var lastdate = start;
      var doloop = true;

      var index = 0;


      while (doloop) {
        lastdate = lastdate.add(this.interval, 'm');

        if (moment(lastdate).diff(end, "minutes") > 0) {
          doloop = false;
        } else {
          index++;
        }
      }

     // console.log(index);

      index--;

      var dataPoints = this.chartData;

      var counts = dataPoints.datasets[0].data;

      counts[index] = counts[index] + 1;

     // console.log(counts)

      dataPoints.datasets[0].data = counts;

      this.chartData = dataPoints;

      this.renderChart(this.chartData, this.options);



    }
  },
  mounted () {
    this.addPlugin(zoom);

    this.getDataFromApi(()=> {
      this.subscribeToStore();
     //
     //  setInterval(() => {
     //      this.incrementLastTimePeriod();
     // }, 1000)
    });

  }
}



// WEBPACK FOOTER //
// ./src/components/graphs/IndividualUserActivity.js